module.exports = __webpack_public_path__ + "static/media/G2.6c74173b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/gp/G2.jpg
// module id = 76
// module chunks = 0